import axios from 'axios';
import { API_HOST } from '../consts';

const fetchCityState = async (params) => {
  const res = await axios.get(`${API_HOST}/cities/city`, { params });
  return res.data;
};

export default fetchCityState;
